import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/globals.css';
import { AppProvider } from './providers';
import { AppRouter } from './routing';

const root = document.getElementById('root');
if (!root) throw new Error('root element not found');

// [TODO:sentry] Sentry 도입 시 createRoot 옵션 (onCaughtError / onUncaughtError / onRecoverableError)
// Reference: https://docs.sentry.io/platforms/javascript/guides/react/features/error-boundary/
createRoot(root).render(
  <StrictMode>
    <AppProvider>
      <AppRouter />
    </AppProvider>
  </StrictMode>,
);
